import {inject} from '@angular/core';
import {catchError, exhaustMap, map, mergeMap, of, take} from 'rxjs';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {LocationsHttpService} from "../../services/locations/locations-http.service";
import {LocationActions, LocationsAPiActions, LocationsChannelActions} from "./locations.actions";
import {LocationModel} from "../../../models/location.model";
import {LocationsChanelService} from "../../services/locations/locations-chanel.service";
import {Store} from "@ngrx/store";
import {locationsFeature} from "./locations.state";

export const getLocations = createEffect(
  (actions$ = inject(Actions),
   locationsHttpService = inject(LocationsHttpService)
  ) => {
    return actions$.pipe(
      ofType(LocationsAPiActions.getLocations),
      mergeMap(payload => {
        return locationsHttpService.getLocations(payload.payload).pipe(
          map((locations: LocationModel[]) => {
            return LocationsAPiActions.getLocationsSuccess({locations: locations})
          }),
          catchError((error: { message: string }) => of(LocationsAPiActions.getLocationsFailure({error})))
        )
      })
    );
  },
  {functional: true}
);

export const getLocation = createEffect(
  (actions$ = inject(Actions),
   locationsHttpService = inject(LocationsHttpService)
  ) => {
    return actions$.pipe(
      ofType(LocationsAPiActions.getLocation),
      mergeMap(payload => {
        return locationsHttpService.getLocation(payload.holderId, payload.holder).pipe(
          map((location: LocationModel) => LocationsAPiActions.getLocationSuccess({location: location})),
          catchError((error: { message: string }) => of(LocationsAPiActions.getLocationFailure({error}))),
        )
      })
    );
  },
  {functional: true}
);

export const subscribeLocationsChannel = createEffect(
  (actions$ = inject(Actions),
   locationsChanelService = inject(LocationsChanelService),
   locationsStore = inject(Store<LocationModel>)) => {
    return actions$.pipe(
      ofType(LocationsAPiActions.getLocationsSuccess, LocationsAPiActions.getLocationSuccess, LocationActions.setLocations),
      mergeMap(payload => locationsStore.select(locationsFeature.selectAll).pipe(take(1))),
      map((locations: LocationModel[]) => {
        const locationIds = locations.map(l => l.holderId);
        locationIds.forEach(locationId => locationsChanelService.subscribeById(locationId));
        // locationsChanelService.subscribe(locationIds)
      })
    );
  },
  {functional: true, dispatch: false}
);


export const unsubscribeAllLocationsChannel = createEffect(
  (actions$ = inject(Actions),
   locationsChanelService = inject(LocationsChanelService)) => {
    return actions$.pipe(
      ofType(LocationsChannelActions.unsubscribe, LocationActions.removeAll),
      map(payload => {
          locationsChanelService.unSubscribeAll();
          return LocationsChannelActions.unsubscribeSuccess();
        }
      )
    );
  },
  {functional: true}
);

export const unsubscribeLocationChannels = createEffect(
  (actions$ = inject(Actions),
   locationsChanelService = inject(LocationsChanelService)) => {
    return actions$.pipe(
      ofType(LocationActions.removeLocations),
      map(payload => {
          payload.ids?.forEach(locationId => locationsChanelService.unSubscribeById(locationId));
          return LocationsChannelActions.unsubscribeSuccess();
        }
      )
    );
  },
  {functional: true}
);


export const subscribeAllLocationsChannel = createEffect(
  (actions$ = inject(Actions),
   locationsChanelService = inject(LocationsChanelService)) => {
    return actions$.pipe(
      ofType(LocationsChannelActions.subscribe),
      mergeMap(payload =>
        locationsChanelService.getChannelsValues().pipe(
          map((notification) => {
            return LocationsChannelActions.notificationReceived({notification: notification})
          })
        )
      )
    );
  },
  {functional: true}
);







